import { useAttachments } from '@/features/conversation/queries/attachments.queries';
import { ReplyLinkPreview } from '@/features/messages/components/message-reply-preview';
import { AttachmentType } from '@/features/messages/models/attachment';
import { Box, Button, Link as MuiLink, Typography } from '@mui/material';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import EmptyState from './empty-state';
import ErrorState from './error-state';
import LoadingState from './loading-state';

interface LinkTabPanelProps {
  conversationId: string;
}

export const LinkTabPanel: FC<LinkTabPanelProps> = ({ conversationId }) => {
  const { t } = useTranslation();
  const { files, isLoading, isError, hasNextPage, fetchNextPage, isFetchingNextPage } = useAttachments({
    conversationId,
    contentType: AttachmentType.LINK,
    limit: 20
  });

  if (isLoading) return <LoadingState />;
  if (isError) return <ErrorState />;
  if (!files.length) return <EmptyState />;

  return (
    <Box className='mex:px-2'>
      <div className='mex:flex mex:flex-col mex:gap-2'>
        {files.map((item: any) => {
          const att = item.attachment as any;
          const url = att.url as string | undefined;
          return (
            <div
              key={item.messageId || item.id || Math.random()}
              className='mex:rounded mex:border mex:border-divider mex:p-2'
            >
              <MuiLink href={url} target='_blank' rel='noopener noreferrer' underline='none' color='inherit'>
                <ReplyLinkPreview attachment={{ ...att, contentType: AttachmentType.LINK } as any} />
              </MuiLink>
            </div>
          );
        })}
      </div>

      {hasNextPage && !isFetchingNextPage && (
        <Box className='mex:pt-2 mex:text-center'>
          <Button
            variant='text'
            size='small'
            onClick={() => fetchNextPage()}
            className='mex:!text-blue-500 mex:hover:!text-blue-700'
          >
            Xem thêm
          </Button>
        </Box>
      )}

      {isFetchingNextPage && (
        <Box className='mex:pt-2 mex:text-center'>
          <Typography variant='body2' className='mex:text-gray-500'>
            {t('conversations.loading.default')}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default LinkTabPanel;
